<template>
  <div class="comment">
    <div class="form">
      <p style="text-align: left;font-weight: 700;">来说点儿什么吧...</p>
      <el-form label-position="left" label-width="100px" :model="form">
         <el-form-item label="您的姓名:" required>
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱:" required>
            <el-input v-model="form.email"></el-input>
          </el-form-item>
      </el-form>
    </div>
    <div class="panel">
      <p style="text-align: left;">留言内容：</p>
          <el-input
            type="textarea"
            :rows="8"
            placeholder="请输入内容"
            v-model="textarea">
          </el-input>
      <div class="btn">
        <el-button type="primary">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: 'Comment',
    data(){
      return {
        form:{
          name:'',
          email:''
        },
        textarea:''
      }
    }
  }
</script>

<style lang="scss">
  .form{
    width: 40%;
  }
  .btn{
    margin: 30px 0;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/leave-msg/components/comment.vue